// extracted by mini-css-extract-plugin
export default {"card":"card_card__fwpCD","card_img":"card_card_img__n20QA","vid":"card_vid__M536W","selectBtn":"card_selectBtn__8FU9Q","resultPage":"card_resultPage__QG3yd"};